<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-notice">
            <div class="notice-header">
              <h3 class="title">
                <div class="item">
                  공지사항 등록
                </div>
              </h3>
            </div>
            <div class="notice-write">
              <div class="body">
                <!-- 필수 : required -->
                <div class="field status required">
                  <div class="caption">
                    상태
                  </div>
                  <div class="content">
                    <div class="contain">
                      <ul class="item check radio">
                        <li class="active">
                          <label>
                            <input type="radio" v-model="status" value="ACTIVE" />
                            <i></i>
                            <span>활성화</span>
                          </label>
                        </li>
                        <li class="inactive">
                          <label>
                            <input type="radio" v-model="status" value="PASSIVE" />
                            <i></i>
                            <span>비활성화</span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- 필수 : required -->
                <div class="field type required">
                  <div class="caption">
                    유형
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item select">
                        <div class="formSelect" ref="select01" @click="openSelect01">
                          <div class="formSelectList">
                            <input type="text" :value="((noticeType===null) || (noticeType==='')) ? '' : findNoticeTypeName(noticeType)" placeholder="유형을 선택하세요." readonly />
                          </div>
                          <div class="formSelectPopup select01">
                            <div class="formSelectPopup-container">
                              <div class="outer">
                                <div class="inner">
                                  <div class="formSelectPopup-box">
                                    <div class="formSelectPopup-zone">
                                      <div class="formSelectPopup-header">
                                        <input type="text" placeholder="검색어를 입력하세요." />
                                      </div>
                                      <ul class="formSelectPopup-body">
                                        <li>
                                          <label>
                                            <input type="radio" v-model="noticeType" value="Version"/>
                                            <input type="checkbox" />
                                            <i></i>
                                            <span>버전</span>
                                          </label>
                                        </li>
                                        <li>
                                          <label>
                                            <input type="radio" v-model="noticeType" value="Event"/>
                                            <input type="checkbox" />
                                            <i></i>
                                            <span>이벤트</span>
                                          </label>
                                        </li>
                                        <li>
                                          <label>
                                            <input type="radio" v-model="noticeType" value="Checking"/>
                                            <input type="checkbox" />
                                            <i></i>
                                            <span>확인중</span>
                                          </label>
                                        </li>
                                      </ul>
                                      <div class="formSelectPopup-footer">
                                        <button class="formSelectPopup-cancel">
                                          취소
                                        </button>
                                        <!-- 비활성(Attribute) : disabled -->
                                        <button class="formSelectPopup-confirm">
                                          확인
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 필수 : required -->
                <div class="field object required">
                  <div class="caption">
                    대상
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item select">
                        <div class="formSelect" ref="select02">
                          <div class="formSelectList" @click="openSelect02">
                            <input type="text" :value="select02Value" placeholder="대상을 선택하세요." readonly />
                          </div>
                          <div class="formSelectPopup typeMulti typeSearch select02">
                            <div class="formSelectPopup-container">
                              <div class="outer">
                                <div class="inner">
                                  <div class="formSelectPopup-box">
                                    <div class="formSelectPopup-zone">
                                      <div class="formSelectPopup-header">
                                        <input type="text" v-model="searchValue" placeholder="검색어를 입력하세요." v-on:keyup="changeSearchValue"/>
                                      </div>
                                      <ul class="formSelectPopup-body">
                                        <li>
                                          <label>
                                            <input type="radio" />
                                            <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                                            <i></i>
                                            <span>전체선택</span>
                                          </label>
                                        </li>
                                        <li v-for="club_info in selectClubInfoList" :key="club_info.ccode">
                                          <label>
                                            <input type="radio"/>
                                            <input type="checkbox" v-model="targetList" :value="club_info.ccode"/>
                                            <i></i>
                                            <span>{{club_info.club_name}}</span>
                                          </label>
                                        </li>
                                      </ul>
                                      <div class="formSelectPopup-footer">
                                        <button class="formSelectPopup-cancel" @click="cancelSelect02">
                                          취소
                                        </button>
                                        <!-- 비활성(Attribute) : disabled -->
                                        <button class="formSelectPopup-confirm" @click="confirmSelect02">
                                          확인
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul class="item check checkbox">
                        <li>
                          <label>
                            <input type="checkbox" v-model="alarm"/>
                            <i></i>
                            대상 골프클럽에 알림 발송
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- 필수 : required -->
                <div class="field title required">
                  <div class="caption">
                    제목
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item input">
                        <input type="text" placeholder="제목을 입력하세요." v-model="title" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field write">
                  <textarea placeholder="내용을 입력하세요." v-model="content"></textarea>
                </div>
              </div>
            </div>
            <div class="notice-button">
              <button class="cancel" @click="moveMenu('/CS001')">
                취소
              </button>
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="submit_before_alert" :disabled="!passValidation">
                등록
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <!-- 확인만(Class) : typeConfirm -->
      <div :class="beforeConfirm ? 'alert' : 'alert typeConfirm'">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAndCancelAlert">
                      취소
                    </button>
                    <button class="confirm" @click="closeAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01" @click="openSelect01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" v-model="noticeType" value="Version"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>버전</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" v-model="noticeType" value="Event"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>이벤트</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" v-model="noticeType" value="Checking"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>확인중</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup typeMulti typeSearch typeSearch select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" v-model="searchValue" placeholder="검색어를 입력하세요." v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                        <i></i>
                        <span>전체선택</span>
                      </label>
                    </li>
                    <li v-for="club_info in selectClubInfoList" :key="club_info.ccode">
                      <label>
                        <input type="radio"/>
                        <input type="checkbox" v-model="targetList" :value="club_info.ccode"/>
                        <i></i>
                        <span>{{club_info.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="cancelSelect02">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect02">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {aplManagerService, settingService, userService} from '../../router'

export default {
  name: 'CS003',
  data () {
    return {
      beforeConfirm: true,
      alertBodyHTML: '공지사항 등록하면 대상골프클럽에게<br />\n' +
        '알림이 발송됩니다.<br />\n' +
        '이대로 등록하시겠습니까?',
      callback: null,
      userInfo: {},
      searchValue: '',
      alarm: true,
      loading: true,
      content: '',
      title: '',
      targetList: [],
      currentTargetList: [],
      clubInfoList: [],
      status: 'ACTIVE',
      noticeType: '',
      targetAllYn: 0,
      selectClubInfoList: [],
      noticeTypeCodeList: [
        {
          noticeCode: 'Version',
          noticeName: '버전'
        },
        {
          noticeCode: 'Event',
          noticeName: '이벤트'
        },
        {
          noticeCode: 'Checking',
          noticeName: '확인중'
        }
      ]
    }
  },
  created: function () {
  },
  mounted: function () {
    aplManagerService.getManagementUserClubName().then(response => {
      this.clubInfoList = response.data.clubInfoList
      this.selectClubInfoList = response.data.clubInfoList
      this.clubInfoList.forEach(function (element) {
        element.selected = false
      })
      userService.getAll().then(response => {
        this.userInfo = response.data
        console.log('userInfo:')
        console.log(this.userInfo)
      })
      this.setData()
    }).catch(error => {
      console.log('aplManagerService.getManagementUserClubName.err.===>', error)
    })
  },
  destroyed: function () {
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  computed: {
    passValidation: function () {
      if (!this.content) return false
      if (!this.title) return false
      if (!this.status) return false
      if (!this.targetList.length) return false
      if (!this.noticeType) return false
      return true
    },
    select02Value: function () {
      if (!this.targetList.length) return ''
      if (this.targetList.length === 1) {
        let target = this.clubInfoList.filter(el => {
          return el.ccode === this.targetList[0]
        })
        return target[0].club_name
      }
      if (this.targetList.length === this.clubInfoList.length) return '전체'
      return `골프클럽(${this.targetList.length})`
    },
    allSelected: function () {
      return this.targetList.length === this.clubInfoList.length
    }
  },
  methods: {
    closeAndCancelAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback = null
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    changeSearchValue: function () {
      this.selectClubInfoList = this.clubInfoList.filter(it => it.club_name.includes(this.searchValue))
    },
    selectAll: function () {
      if (this.allSelected) {
        this.targetList = []
      } else {
        this.targetList = this.clubInfoList.map(it => it.ccode)
      }
    },
    openSelect02: function () {
      if (document.querySelector('body.type-content.select02Active') !== null) {
        this.cancelSelect02()
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select02Active`)
        document.querySelector('body.type-content').classList.add('multiSelect')
      }
    },
    cancelSelect02: function () {
      this.closeSelectAll()
    },
    confirmSelect02: function () {
      this.currentTargetList = this.targetList
      this.closeSelectAll()
    },
    closeSelectAll: function () {
      document.querySelector('body.type-content').classList.remove(`select01Active`)
      document.querySelector('body.type-content').classList.remove(`select02Active`)
      document.querySelector('body.type-content').classList.remove(`select03Active`)
      document.querySelector('body.type-content').classList.remove(`select04Active`)
      document.querySelector('body.type-content').classList.remove(`multiSelect`)
      this.tooltipActive = false
      this.targetList = this.currentTargetList
    },
    submit_before_alert: function () {
      if (!this.passValidation) {
        this.beforeConfirm = false
        this.openAlert('필수 입력사항을<br />확인해주세요.', null)
        return
      }
      this.beforeConfirm = true
      this.alertBodyHTML = '공지사항 등록하면 대상골프클럽에게<br />\n 알림이 발송됩니다.<br />\n 이대로 등록하시겠습니까?'
      if (this.alarm) {
        this.openAlert(this.alertBodyHTML, function () {
          this.submit_data()
        })
      } else {
        this.submit_data()
      }
    },
    submit_data: function () {
      let targetList = []
      if (this.targetList.length === this.clubInfoList.length) {
        this.targetAllYn = 1
      } else {
        targetList = this.targetList.join(',')
      }

      aplManagerService.postNotice(this.noticeType, this.status, this.title, this.content, this.targetAllYn, targetList).then(response => {
        this.selectClubInfoList.forEach(function (element) {
          element.selected = false
        })
        if (this.alarm) {
          settingService.insertPushAlarm({
            funcId: '5',
            pageId: 'CS-003',
            message: this.title,
            pageQuery: `?notice_id=${response.insertId}`,
            ccodes: this.targetList
          }).then(() => {
            this.beforeConfirm = false
            this.openAlert('등록되었습니다.', function () {
              this.moveMenu('/CS002?notice_id=' + response.insertId)
            })
          })
        } else {
          this.beforeConfirm = false
          this.openAlert('등록되었습니다.', function () {
            this.moveMenu('/CS002?notice_id=' + response.insertId)
          })
        }
      }).catch(error => {
        console.log('postNotice.err.===>', error)
      })
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    findNoticeTypeName: function (noticeType) {
      if (this.noticeTypeCodeList.find(it => it.noticeCode === noticeType) !== undefined) {
        return this.noticeTypeCodeList.find(it => it.noticeCode === noticeType).noticeName
      } else {
        return ''
      }
    },
    moveMenu: function (path) {
      this.$router.push(path)
    },
    setData: function () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS003.vue